import { render } from "./EditJobDetails.vue?vue&type=template&id=7d579bb4"
import script from "./EditJobDetails.vue?vue&type=script&lang=js"
export * from "./EditJobDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__